function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import { getSpzaUserIdAndNewUserModifier } from '@shared/utils/appUtils';
import { scrubField } from '@shared/utils/scrubbingUtils';
const predefinedPLT = {
    scriptStart: -1,
    hydrationStart: -1
};
function currentSinceRequestStart() {
    var _getWindow_performance, _getWindow, _getWindow_performance1, _getWindow1;
    const { navigationStart = 0, requestStart = 0 } = ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_performance = _getWindow.performance) === null || _getWindow_performance === void 0 ? void 0 : _getWindow_performance.timing) || {};
    return ((_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : (_getWindow_performance1 = _getWindow1.performance) === null || _getWindow_performance1 === void 0 ? void 0 : _getWindow_performance1.now()) - (requestStart - navigationStart);
}
export function setScriptStart() {
    predefinedPLT.scriptStart = currentSinceRequestStart();
}
export function setHydrationStart() {
    predefinedPLT.hydrationStart = currentSinceRequestStart();
}
function getAssetsLoadTime() {
    var _getWindow_performance, _getWindow, _getWindow_performance1, _getWindow1;
    const { navigationStart = 0, requestStart = 0 } = ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_performance = _getWindow.performance) === null || _getWindow_performance === void 0 ? void 0 : _getWindow_performance.timing) || {};
    const perfEntries = ((_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : (_getWindow_performance1 = _getWindow1.performance) === null || _getWindow_performance1 === void 0 ? void 0 : _getWindow_performance1.getEntriesByType('resource')) || [];
    return perfEntries.filter(({ initiatorType })=>initiatorType === 'script' || initiatorType === 'link').map(({ name: src, responseEnd })=>({
            src,
            requestStart,
            responseEnd,
            duration: responseEnd - (requestStart - navigationStart)
        }));
}
const whiteListedAssets = [
    'staticstorage',
    'agorasstatic'
];
function getSlowestAssetDuration({ assets }) {
    return assets.filter(({ src })=>whiteListedAssets.some((whiteListedAsset)=>src.includes(whiteListedAsset))).sort((a, b)=>b.duration - a.duration)[0];
}
export function telemetryPageLoadTime({ isEmbedded, landingView }) {
    if (!getWindow()) {
        return;
    }
    const performanceNow = getWindow().performance.now();
    const { navigationStart = 0, requestStart = 0, responseStart = 0, responseEnd = 0 } = getWindow().performance.timing;
    const duration = performanceNow - (requestStart - navigationStart);
    const { scriptStart, hydrationStart } = predefinedPLT;
    const assets = getAssetsLoadTime();
    const { duration: slowestAssetDuration, src: slowestAssetURL } = getSlowestAssetDuration({
        assets
    }) || {};
    const { spzaUserId: spzaId } = getSpzaUserIdAndNewUserModifier() || {};
    const hostType = isEmbedded ? Constants.appSourceEmbed : Constants.appSource;
    const pageLoadTime = {
        hostType,
        landingView,
        responseStart: Math.max(responseStart - requestStart, 0),
        responseEnd: Math.max(responseEnd - requestStart, 0),
        scriptStart,
        hydrationStart,
        performanceNow,
        duration,
        durationSinceRequestStart: duration,
        slowestAssetDuration,
        slowestAssetURL: scrubField(slowestAssetURL)
    };
    getWindow().pageLoadTime = pageLoadTime;
    getWindow().telemetry({
        action: Constants.Telemetry.Action.RootHandler,
        actionModifier: Constants.Telemetry.ActionModifier.End,
        details: pageLoadTime,
        spzaId
    });
    const scrubbedAssets = assets.map((asset)=>_object_spread_props(_object_spread({}, asset), {
            src: scrubField(asset.src)
        }));
    getWindow().telemetry({
        action: Constants.Telemetry.Action.PerfResources,
        actionModifier: Constants.Telemetry.ActionModifier.Complete,
        details: {
            length: assets.length,
            assets: scrubbedAssets
        },
        spzaId
    });
    getWindow().flushTelemetry();
}
